<template>
    <v-row>
        <v-col cols="12" class="pb-1">
            <v-divider class="mb-5"></v-divider>
            <div class="d-flex justify-space-between align-center">
                <span class="title">
                    <v-icon>feedback</v-icon>
                    {{ $t('contracts.form.additive.title') }}
                </span>
                <contract-additive-dialog :show.sync="additiveDialog.show" :additiveDetail.sync="additiveDialog.additiveIndex" :contract.sync="contract" @close-additive-dialog="reOrder"></contract-additive-dialog>
            </div>
        </v-col>
        <v-col cols="12" v-if="contract.additive.length < 1">
            <div class="text-center"><span style="color: red">{{ $t('contracts.form.additive.empty') }}</span></div>
        </v-col>
        <v-col cols="12" class="pt-1 pb-1" v-else>
            <template v-for="(item, index) in contract.additive">
                <v-card
                    :key="index"
                    v-if="item.status != 3 || viewAllAdditives"
                    class="contract-additive-item mx-auto mb-1"
                    :class="{ pending: item.status == 1, signed: item.status == 2, canceled: item.status == 3 }"
                    outlined
                >
                    <v-card-title class="headline pt-2"><strong>{{ item.additive }}</strong></v-card-title>
                    <v-card-subtitle class="pb-0">
                        {{ $t('contracts.form.additive.status') }} <span class="status-label ml-1"><strong>{{ item.status | additiveStatusString }}</strong></span>
                        <template v-if="item.status == 2"><br/><span>{{ $t('contracts.form.additive.signDate') }} <span class="ml-1"><strong>{{ item.signatureDate.iso | momentFormatDateNoISO('L') }}</strong></span></span></template>
                        <template v-if="item.status == 3"><br/><span>{{ $t('contracts.form.additive.cancelDate') }} <span class="ml-1"><strong>{{ item.cancellationDate.iso | momentFormatDateNoISO('L') }}</strong></span></span></template>
                    </v-card-subtitle>
                    <v-card-actions class="pt-1 pb-1 pl-4 pr-4">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error"
                            text
                            small
                            @click.prevent="deleteAdditive(index, item)"
                        >
                            {{ $t('common.remove') }}
                        </v-btn>
                        <v-btn
                            color="indigo"
                            dark
                            depressed
                            small
                            @click.prevent="showDetails(index, item)"
                        >
                            {{ $t('common.details') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-col>
        <v-col cols="12" v-if="showToggle">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="toggleAllAdditives()"
                small
            >
                {{viewAllAdditives ? $t('contracts.form.additive.hideCanceleds') : $t('contracts.form.additive.showCanceleds')}}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import ContractAdditiveDialog from '@/components/contract/ContractAdditiveDialog'

export default {
    name: 'contract-additive',
    components: {
        ContractAdditiveDialog
    },
    props: ['contract'],
    data () {
        return {
            viewAllAdditives: false,
            additiveDialog: {
                show: false,
                additiveIndex: undefined
            }
        }
    },
    mounted () {
        this.reOrder()
    },
    computed: {
        showToggle () {
            let hasCanceleds = this.contract.additive.filter(function (additive) {
                return additive.status === 3
            })
            return (hasCanceleds.length > 0)
        }
    },
    methods: {
        reOrder () {
            this.contract.additive.sort(function (a, b) {
                if (a.addendumDate.iso.toLowerCase() > b.addendumDate.iso.toLowerCase()) return -1
                if (a.addendumDate.iso.toLowerCase() < b.addendumDate.iso.toLowerCase()) return 1
            })
            this.contract.additive.sort(function (a, b) {
                if (a.additive < b.additive) return -1
                if (a.additive > b.additive) return 1
            })
            this.$forceUpdate()
        },
        toggleAllAdditives () {
            this.reOrder()
            this.viewAllAdditives = !this.viewAllAdditives
        },
        showDetails (index, additive) {
            this.additiveDialog.show = true
            this.additiveDialog.additiveIndex = index
        },
        deleteAdditive (index) {
            window.getApp.refreshContracts = true
            if (this.contract.additive[index].objectId) {
                this.contract.additiveRemoved.push(this.contract.additive[index])
            }
            this.contract.additive.splice(index, 1)
            this.$forceUpdate()
        }
    }
}
</script>

<style lang="stylus" scoped>
    .contract-additive-item >>> .wrapper-read-only
        margin-top: 0 !important
    .contract-additive-item.pending
        border: thin solid rgba(255, 165, 0, 1)
        .status-label
            color: rgba(255, 165, 0, 1)
    .contract-additive-item.signed
        border: thin solid rgba(63, 81, 181, 1)
        .status-label
            color: rgba(63, 81, 181, 1)
    .contract-additive-item.canceled
        border: thin solid rgba(255, 0, 0, 1)
        .status-label
            color: rgba(255, 0, 0, 1)
</style>
